module.exports = __webpack_public_path__ + "img/VuelaAngelito.7ca71534.png";